export default "__VITE_ASSET__B$z3uk$9__"